<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">
    <!-- TITLE -->
    <h2 v-if="this.pathname && !this.pathname.includes('/search')">
      {{ $t('menu.myRequestsGroup') }}
    </h2>
    <!-- END TITLE -->

    <!-- FILTERS -->
    <v-card v-if="renderFilters && changeurl">
      <!-- SEARCH -->
      <v-row
        no-gutters
        align="center"
        class="px-4 mt-4"
      >
        <v-col class="pt-3">
          <Searchbar
            ref="filterComponent"
            :placeholder="$t(`views.ticketList.search.placeholder.R`)"
            @search="submit"
          ></Searchbar>
        </v-col>
      </v-row>

      <!-- CHIPS -->
      <v-row
        no-gutters
        :class="['mt-4', 'align__end', { 'px-4': $vuetify.breakpoint.smAndUp }]">
        <v-col>
          <div class="px-4 showWeb myRequestScroll container__chip">
            <v-chip
              v-show="firstLoadDone"
              v-for="(filter, index) in filtersInitialRequests"
              :key="index"
              :class="[filters.status.includes(filter.status)
                ? 'chip__active'
                : '',
                'chip__agrupaciones chip__filter v-chip']"
              @click="filterSearch(filter)"
            >
              <v-badge
                :key="index"
                class="d-inline"
                inline
                :color="filter.status ? colors(filter.status) : ''"
                dot
              ></v-badge>
              {{ textFilters(filter.status) }}
            </v-chip>
          </div>

          <FiltersSlide
            v-if="showFilters"
            :isBadge="isBadge"
            :filters="filtersInitialRequests"
            :selectedFilters="filters.status"
            @filter-selected="filterSearch"
          />
        </v-col>

        <!-- EXPORT ACTION -->
        <!-- MOBILE_DISABLED_EXPORT -->
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && get('deviceOS') == null"
          v-show="Number(this.total) && firstLoadDone"
          color="primary"
          outlined
          :disabled="exportLoading"
          @click="exportTickets()"
        >
          <v-icon class="mr-2">mdi-file-excel</v-icon>
          {{ $t("views.ticketList.export") }}
        </v-btn>
      </v-row>

      <!-- ERROR -->
      <v-row
        v-if="isErrorCancel"
        no-gutters
        class="px-6 mt-4"
      >
        <v-col>
          <span class="error--filter">
            {{ $t('validation.dateRangeClosed') }}
          </span>
        </v-col>
      </v-row>

      <!-- DATE -->
      <v-row
        no-gutters
        class="mb-4"
      >
        <v-card-text v-show="firstLoadDone" id="list-filters-item" class="list-filters-item">
          <div class="d-flex align-center flex-wrap filters-row">
            <FormDate
              id="form-filters-approvers"
              class="form-date-wrapper"
              ref="form"
              :buttons="[ $t('views.ticketList.filters.search') ]"
              :data="formFiltersConfiguration"
              :filterStatus="filters.status"
              @click:submit="submit"
              @keyup.enter="submit"
            ></FormDate>
            <span
              v-show="firstLoadDone"
              :class="'chip__agrupaciones chip__filter v-chip ml-2 mr-4 mt-0'"
            >
              <div class="chipMenu">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      density="compact"
                      variant="text"
                      v-on="on"
                      class="btn__filter"
                      :ripple="false"
                      @click="() => { menuOwnerFlag = !menuOwnerFlag }"
                    >
                      <span>
                        <b>Solicitudes:</b> {{ findOwnerName() }}
                      </span>
                      <v-icon class="iconChips">
                        {{ !menuOwnerFlag ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list class="listSheet">
                    <template v-for="(item, index) in ownerFilter">
                      <v-list-item
                        link
                        class="listSheetItem"
                        :key="index + item.value"
                      >
                        <v-list-item-title
                          class="listSheetTitle"
                          @click="handleOwnerFilter(item)"
                        >
                          <v-icon size="16" class="iconChips iconChipSize">
                            {{ item.active ? 'mdi-check-bold' : '' }}
                          </v-icon>
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        v-if="index < ownerFilter.length - 1"
                        :key="index * 2"
                      />
                    </template>
                  </v-list>
                </v-menu>
              </div>
            </span>

            <v-switch
              v-show="firstLoadDone"
              v-model="hideClaims"
              class="ml-2 mt-4 mb-4 pt-0"
              label="Ocultar reclamaciones"
              hide-details
              dense
            ></v-switch>
          </div>
        </v-card-text>
      </v-row>
    </v-card>

    <!-- LIST SKELETON LOADER -->
    <template v-if="!loadingRequestTicket">
      <template >
        <v-card class="mt-4 py-2">
          <v-skeleton-loader
            v-for="i in 7"
            :key="i"
            type="list-item"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
    </template>
    <!-- END LIST SKELETON LOADER -->

    <div class="mt-4 text-body" v-if="loadingRequestTicket && tickets.length === 0">
      <span v-if="firstSearch"
      v-html="$t('views.globalSearch.requestsItems.notFoundSearchFirstLoad',
        [querySearch || dataSearch])">
      </span>
      <span v-else
        v-html="$t('views.globalSearch.requestsItems.notFoundSearch',
        [querySearch || dataSearch])">
      </span>
    </div>

    <div
      class="mt-2 hoverItem"
      v-if="firstLoadDone"
    >
      <!-- TICKETS LIST DETAILS -->
      <ListItem
        v-for="(ticket, index) in tickets"
        :key="index"
        :url="`${goDetail}/${ticket.id}`"
        :class="{ 'pt-2': true}"
      >
      <!-- :class="{ 'pt-2': !pathSelect(), 'mt-4': pathSelect(),}" -->
        <template v-slot:title>
          <div class="inlineFlexMW90">
            <div class="alignItemCenter titleTicket">
              <!-- TITLE -->
              <!-- <v-chip v-if="pathSelect()"
                class="ma-2"
                label small
                color="primary"
              >
                {{ ticket.referenceNumber }}
              </v-chip> -->

              <span
                v-if="$vuetify.breakpoint.mdAndUp"
                v-bind:class="['item-title', {
                  'item-title-end': !$vuetify.breakpoint.smAndUp
                }]"
              >
                <!-- <i v-if="!pathSelect()"> {{ ticket.referenceNumber }}</i> - -->
                <i class="titleTicket"> {{ ticket.referenceNumber }}</i> -
                {{ ticket.summary }}
              </span>

              <v-spacer />

              <span
                v-if="!$vuetify.breakpoint.mdAndUp"
                style="width: 100%"
                v-bind:class="['item-title', {
                  'item-title-end': !$vuetify.breakpoint.smAndUp
                }]"
              >
              <i class="titleTicket"> {{ ticket.referenceNumber }}</i> -
                {{ ticket.summary }}
              </span>
            </div>
          </div>
        </template>

        <template v-slot:subtitle>
          <div v-html="(ticket.description || '').replace(/\n/ig, '<br>')"></div>
          <v-spacer />
        </template>

        <template v-slot:footer class="pa-0">
          <div class="item__flex--center">
            <!-- TIPO DE SOLIICTUD  -->
            <v-avatar
              v-if="ticket.status != null"
              class="initialColor"
              :color="ticket.status.code ? colors(ticket.status.code) : ''"
              size="25"
            >
              <v-icon
                class="initialColorIcon"
                :color="colors(ticket.status.code)"
                v-text="textIcon(ticket)"
              ></v-icon>
            </v-avatar>

            <!-- ICONOS SEGUIDOR-INTERESADOS -->
            <i v-if="ticket.isSuscriptor"
              class="icon__interesado--request
              icon-ayudadigital-interesados-negativo iconTicket"></i>
            <i v-else-if="ticket.isSeguidor"
              class="icon__seguidor--request icon-ayudadigital-ojo iconTicket"></i>
            <i v-else class="iconNone iconTicket"></i>

            <!-- TIME -->
            <template v-if="ticket.openDate">
              {{ $t("views.ticketList.openDate", [ $date('formatTime', ticket.openDate) ]) }}
            </template>

            <template v-if="ticket.lastModDt">
              {{ $t("views.ticketList.lastModDt", [ $date('formatTime', ticket.lastModDt) ]) }}
            </template>

            <template v-if="ticket.resolveDate">
              {{ $t("views.ticketList.resolveDate", [ $date('formatTime', ticket.resolveDate) ]) }}
            </template>

            <template v-if="(ticket.status || {}).relAttr === 'CL' && ticket.closeDate">
              {{ $t("views.ticketList.closeDate", [ $date('formatTime', ticket.closeDate) ]) }}
            </template>
          </div>
        </template>
      </ListItem>

      <InfiniteScroll
        :size="10"
        v-if="firstLoadDone && total > 15 && (loading || pagesize < total)"
        :scroll="loading && firstLoadDone"
        margin="400px"
        root="html"
        class="mt-4"
        @scrollList="scrollTickets(15)"
      ></InfiniteScroll>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { NAMED_ROLES } from '@/store/modules/session';
import {
  ListItem, Searchbar, InfiniteScroll, FormDate, FiltersSlide,
} from '@/components';

const b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
  const content = contentType || '';
  const size = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += size) {
    const slice = byteCharacters.slice(offset, offset + size);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: content,
  });
  return blob;
};

export default {
  name: 'TicketsListView',
  components: {
    ListItem,
    Searchbar,
    FormDate,
    InfiniteScroll,
    FiltersSlide,
  },
  props: {
    querySearch: String,
    sort: {
      type: String,
      default: () => 'open_date',
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    asc: {
      type: Boolean,
      default: () => false,
    },
    list: {
      type: Array,
      default: () => ([]),
    },
    renderFilters: {
      type: Boolean,
      default: () => true,
    },
    loading: Boolean,
    firstLoadDone: Boolean,
    goDetail: {
      type: String,
      default: () => '/requests',
    },
    total: {
      type: [String, Number],
      default: () => 0,
    },
    isCatalog: Boolean,
    isKnowledge: Boolean,
    isRequest: Boolean,
  },
  data() {
    return {
      start: 0,
      pagesize: 15,
      exportLoading: false,
      changeurl: true,
      scroll: true,
      pathname: null,
      loadingRequestTicket: true,
      dataSearch: '',
      filtersMyRequest: ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO', 'PEND_PRES', 'CNCL', 'CL', 'RCHZ'],
      firstSearch: false,
      showFilters: false,
      filtersRequests: [],
      filtersInitialRequests: [],
      isBadge: true,
      isErrorCancel: false,
      ownerFilter: [
        { label: 'Todas', value: 'all', active: true },
        { label: 'Propias', value: 'own', active: false },
        { label: 'Interesados', value: 'suscriptor', active: false },
      ],
      menuOwnerFlag: false,
      hideClaims: false,
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    formFiltersConfiguration() {
      // getting base configuration from constants
      const filtersConfigAux = this.$getConst('listFilters.R');
      if (this.user.isUserTecnical) {
        filtersConfigAux.properties[0].params.items = {
          ...filtersConfigAux.properties[0].params.items,
          pendientePresupuesto: {
            label: 'Pte. presupuesto',
            value: 'PEND_PRES',
          },
        };
      }
      if (filtersConfigAux?.properties.find((i) => i?.alias === 'type')) {
        filtersConfigAux.properties = filtersConfigAux?.properties.filter((i) => i?.alias !== 'type');
      }
      const filtersConfiguration = filtersConfigAux;
      filtersConfiguration.properties.forEach((prop) => {
        if (!this.hasRoles(NAMED_ROLES.VIEW_PROBLEM) && prop.alias === 'type') {
          // eslint-disable-next-line no-param-reassign
          delete prop.params.items.Problemas;
        }
      });

      // we will check if there's some property initialized by url parameter
      Object.keys(this.filters)
        .map((filterKey) => filtersConfiguration.properties.find((f) => f.alias === filterKey))
        .filter((filterProperty) => filterProperty != null)
        .forEach((filterProperty) => {
          let value = this.filters[filterProperty.alias];
          let initialvalue = null;
          if (['date', 'datetime'].includes(filterProperty.type.name)) {
            value = value.split('::')
              .map((filterValue) => moment(filterValue, 'DD/MM/YYYY').format('YYYY-MM-DD'));

            if (value.length <= 2) {
              initialvalue = `'${value.join('::')}'`;
            }
          } else {
            initialvalue = Array.isArray(value) ? JSON.stringify(value) : `'${value}'`;
          }

          if (initialvalue != null) {
            // eslint-disable-next-line no-param-reassign
            filterProperty.config.initialvalue = initialvalue;
          }
        });

      /* Condicion solo para la url /requests */
      if ((window.location.pathname).includes('requests') && filtersConfiguration?.properties?.length > 0) {
        const filtersConfigurationAux = filtersConfiguration;
        filtersConfigurationAux.properties[filtersConfigurationAux.properties.map((i) => i.alias).indexOf(('open_date'))].type.name = 'datetimefrom';
        return filtersConfigurationAux;
      }

      return filtersConfiguration;
    },
    tickets() {
      if (!this.list) return [];

      const activeOwner = this.ownerFilter.find((item) => item.active);
      let result = this.list;
      if (activeOwner && activeOwner.value === 'own') {
        result = result.filter((ticket) => !ticket.isSuscriptor);
      } else if (activeOwner && activeOwner.value === 'suscriptor') {
        result = result.filter((ticket) => ticket.isSuscriptor);
      }
      if (this.hideClaims) {
        result = result.filter(
          (ticket) => (ticket.category || {}).id !== this.$getConst('claim.category'),
        );
      }
      return result;
    },
    NAMED_ROLES() {
      return NAMED_ROLES;
    },
  },

  methods: {
    filterSearch(data) {
      this.isErrorCancel = false;
      const { status } = data;
      if ((status !== 'CL') || (status === 'CL'
      && (this.filters.open_date)
      && (this.filters.open_date ? this.rangeDate(this.filters.open_date) : true)
      )) {
        if (this.filters.status.includes(status)) {
          if (this.filters.status.length === 1) {
            // TODO atLeastOneFilter
            console.log('components.searchBox.atLeastOneFilter');
            // this.$store.dispatch('messages/createNotificationMessage', {
            //   type: 'warning',
            //   icon: 'mdi-alert',
            //   title: this.$t('components.searchBox.atLeastOneFilter'),
            //   timeout: this.$getConst('notifications.timeout'),
            // });
            return;
          }
          this.filters.status.splice(this.filters.status.indexOf(status), 1);
        } else {
          this.filters.status.push(status);
        }
        this.isErrorCancel = false;
        console.log(this.isErrorCancel);
        this.submit(this.filters.status);
      } else {
        this.isErrorCancel = true;
      }
    },
    rangeDate(date) {
      const dates = date.split('::');
      const date1 = new Date(moment(dates[0], 'DD/MM/YYYY').format('YYYY-MM-DD'));
      const date2 = new Date(moment(dates[1], 'DD/MM/YYYY').format('YYYY-MM-DD'));
      const rango = (date1.getTime() - date2.getTime()) / (1000 * 3600 * 24);
      return rango > -90;
    },
    pathSelect() {
      return !window.location.pathname.includes('requests');
    },
    textIcon(ticket) {
      if (ticket?.status?.code) {
        const result = this.$getConst(`initialFilters.filterStatus.${ticket.status.code}.initials`);
        return result;
      }
      return '';
    },
    colors(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.color`);
        return result;
      }
      return '';
    },
    textFilters(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.text`);
        return result;
      }
      return '';
    },

    async search(action, start, size, filters) {
      const effectiveFilters = filters || this.filters;
      this.dataSearch = effectiveFilters.search;
      const {
        sort, asc,
      } = this;
      await this.$emit('request', {
        type: 'list',
        args: {
          start,
          size,
          filters: effectiveFilters,
          sort,
          asc,
          action,
        },
      });
    },
    async exportTickets() {
      this.exportLoading = true;
      const exportType = this.$getConst('ticketExport.R');
      const file = await this.$api
        .getClient(exportType)
        .exportTicketsXLS(this.filters);
      const uInt8Array = new Uint8Array(file.data);
      let i = uInt8Array.length;
      const binaryString = new Array(i);
      // eslint-disable-next-line no-plusplus
      while (i--) {
        binaryString[i] = String.fromCharCode(uInt8Array[i]);
      }
      const data = binaryString.join('');
      const base64 = window.btoa(data);

      const blob = b64toBlob(
        base64,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      );
      saveAs(blob, 'download.xlsx');
      this.exportLoading = false;
    },

    submit({ data }) {
      this.isErrorCancel = false;
      this.firstSearch = false;
      let query = {};
      this.start = 0;
      const searchInput = this.$refs.filterComponent.$children[0].value;
      if (data) {
        query = {
          ...data,
          ...this.formFiltersConfiguration.properties
            .filter((property) => ['date', 'datetime', 'datetimefrom'].includes(property.type.name) && data[property.alias])
            .reduce((acum, property) => {
              // [WARN] Check this line if filter property format param changes
              // DD/MM/YYYY - DD/MM/YYYY formatting to URL PARAM
              // eslint-disable-next-line no-param-reassign
              acum[property.alias] = data[property.alias].replace(' - ', '::');
              return acum;
            }, {}),
        };
        this.filters = query;
      } else {
        query = this.filters;
      }
      if (searchInput) {
        query.search = searchInput;
      } else {
        query.search = '';
      }
      // Avoid error to generate url
      this.$router.push({ path: this.$route.path, query }).catch(() => {});
      this.search('list', 0, 15, query);
      this.pagesize = 15;
      // this.$router.push({ name: 'Requests', query: this.filters });
    },
    async scrollTickets(increment) {
      if (this.pagesize <= this.total) {
        this.scroll = true;
        // await this.search('scroll', this.pagesize, this.filters);
        this.search('scroll', this.pagesize, increment, this.filters);
        this.pagesize += increment;
      } else {
        this.scroll = false;
      }
    },
    findOwnerName() {
      return this.ownerFilter.find((item) => item.active).label;
    },
    handleOwnerFilter(item) {
      this.ownerFilter.forEach((elem) => {
        // eslint-disable-next-line no-param-reassign
        elem.active = item.value === elem.value;
      });
    },
    styleObject(type) {
      switch (type) {
      case 'R':
        return '#99c2a5';
      case 'I':
        return '#cdcd9c';
      case 'P':
        return '#c55a11';
      default:
        return '#ff0000';
      }
    },
  },
  watch: {
    firstLoadDone() {
      this.loadingRequestTicket = window.location.pathname.includes('/requests')
        ? this.firstLoadDone
        : this.isRequest;
    },
    isRequest() {
      this.loadingRequestTicket = window.location.pathname.includes('/requests')
        ? this.firstLoadDone
        : this.isRequest;
    },
  },
  created() {
    this.search('list', 0, 15, this.filters);
    this.pathname = window.location.pathname;
    this.loadingRequestTicket = window.location.pathname.includes('/requests')
      ? this.firstLoadDone
      : this.isRequest;

    if (!(window.location.search.includes('q='))) {
      this.firstSearch = true;
    }
  },
  async mounted() {
    this.filtersRequests = this.filters.status;
    this.filtersInitialRequests = this.user.isUserTecnical
      ? this.$getConst('initialFilters.requestTic')
      : this.$getConst('initialFilters.requestNoTic');

    setInterval(() => {
      this.showFilters = true;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>

  .filters-row {
    flex-wrap: wrap;
  }

  .form-date-wrapper {
    flex: 0 0 auto !important;
    width: auto !important;
  }

  .form-date-wrapper :deep(.v-form) {
    width: auto !important;
  }

  .form-date-wrapper :deep(.v-row) {
    width: auto !important;
    margin: 0 !important;
    flex-wrap: nowrap !important;
  }

  .form-date-wrapper :deep(.v-col) {
  flex: 0 1 auto !important;
  flex-basis: auto !important;
  max-width: none !important;
  width: auto !important;
}

  .form-date-wrapper :deep(.v-text-field),
  .form-date-wrapper :deep(.v-input) {
    flex: 0 0 auto !important;
    flex-shrink: 0 !important;
    width: 300px !important;
    min-width: 300px !important;
  }

  .form-date-wrapper :deep(.v-input__slot) {
    flex-shrink: 0 !important;
  }
  .item__flex--center {
    display: flex;
    align-items: center;
  }
  .item-title-end {
    order: 4;
    //padding-left: 1.5rem;
    word-break: keep-all;
  }
  .initialColor{
    font-size: 0.5rem !important;
    //margin-right: 0.5rem;
  }
  .initialColorIcon{
    color: #ffffff !important;
    font-size: 14px !important;
  }
  .filtersChips{
    margin: 0.25rem !important;
  }
  .icon__interesado--request {
    font-size: 3rem
  }
  .icon__seguidor--request {
    font-size: 2.5rem
  }
  .iconNone {
    height: 45px;
    width: 32px;
    // height: 45px;
    // width: 45px;
  }
  .hoverItem :hover{
    background-color: #c8c8c8;
  }
  .chip__active {
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
    padding: 0 16px;
  }
  .showMobile {
    display: none !important;
  }

  .align__end {
    align-items: end !important;
  }
  .list-filters-item {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .list-filters-item .v-form .row > div {
    padding: 0 !important;
  }
  .col-md-4.col-lg-4.col-xl-4.col-12 {
    padding: 0 !important;
  }
  .myRequestScroll.container__chip {
    padding: 0 !important;
  }
  .inlineFlexMW90{
      display: inline-flex;
      max-width: 90%;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
  }
  .iconTicket{
    font-size: 2.5rem;
    min-width: 25px !important;
  }
  .titleTicket{
    font-size: 0.95rem !important;
  }

  .error--filter {
    color: #b64351 !important;
    caret-color: #b64351 !important;
    padding-top: 0px;
    margin-bottom: 8px;
  }

  .chipMenu {
    display: flex;
    align-items: center;
  }
  .btn__filter {
    height: 20px !important;
    width: 100% !important;
    text-transform: initial;
    color: initial !important;
    letter-spacing: initial !important;
  }
  .btn__filter,
  .btn__filter:focus,
  .btn__filter:active,
  .btn__filter::before {
    background-color: transparent !important;
  }
  .iconChips {
    color: #27846d !important;
  }
  .iconChipSize {
    min-width: 16px !important;
    max-width: 16px !important;
  }
  .listSheet {
    background: white;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
  }
  .listSheetItem {
    display: block;
    min-height: 1rem;
    padding: 0.25rem;
  }

  @media screen and (max-width: 600px) {

    .form-date-wrapper :deep(.v-text-field),
    .form-date-wrapper :deep(.v-input) {
      width: 100% !important;
      min-width: 0 !important;
    }

    .form-date-wrapper {
      width: 100% !important;
      flex: 1 1 100% !important;
    }

    .titleTicket{
      font-size: 0.85rem !important;
    }
    .showWeb {
      display: none !important;
    }

    .showMobile {
      display: flex !important;
    }
    .v-slide-group__next--disabled {
      display: none !important;
    }

    .v-slide-group__next {
      min-width: none !important;
    }
    .myRequestScroll {
      overflow: hidden;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 4px;
    }
  }
</style>
